import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'react-redux';
import type { ProviderFiltersState } from './types';
export const getProviderFilters = (state: RootState) => state.providerFilters;

export const getFilterResults = createSelector(
  getProviderFilters,
  (state: ProviderFiltersState) => state.data,
);

export const getIsFetchingFilters = createSelector(
  getProviderFilters,
  (state: ProviderFiltersState) => state.isFetching,
);
